export default __webpack_public_path__ + "static/media/checklist.2ff34e0a.svg";